import React from 'react';

import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

export const CustodianSelect = ({ custodians, onSelect, getOptionLabel }) => {
  const handleChange = (event, value) => {
    onSelect(value);
  };

  return (
    <Autocomplete
      id="rider-select"
      size="small"
      options={custodians}
      getOptionLabel={getOptionLabel}
      style={{ width: 220 }}
      onChange={handleChange}
      renderInput={params => (
        <TextField {...params} label="Select Custodian" variant="outlined" />
      )}
    />
  );
};
